import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import locationData from './location_data.json';
import TempData from './temp_data.json';
import { postToAPI, formatISODateWithTimezone, getFromAPI } from './utils';
import { toast } from "react-toastify";
import messages from './lang';
import FormInputs from './FormInputs';

export default function QuickVendorModal({ addVendorShow, addVendorClose }) {
    const [TempDataOption] = useState(TempData);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedState, setSelectedState] = useState('');

    const initialInputData = {
        name: '',
        company_name: '',
        phone_number1: '',
        email: '',
        gst_number: '',
        country: 0,
        state: 0,
        city: 0,
        tax: 0,
        pan_card_number: '',
        opening_balance: 0.0,
        current_balance: 0.0,
        bank_branch_name: null,
        bank_branch_ifsc_code: null,
        bank_account_number: 0,
        website: null,
        phone_number2: null,
        primary_address: null,
        tax_id: 1,
        tax_type: 1,
        isactive: 1,
        isdeleted: 0,
        created_branch_id: 1,
        created_date_time: formatISODateWithTimezone(new Date()),
        last_modified_date_time: formatISODateWithTimezone(new Date()),
        created_user_id: 1,
        last_modified_user_id: 1
    };
    const [inputData, setInputData] = useState({ ...initialInputData });

    useEffect(() => {
        const fetchCountryData = async () => {
            try {
                const response = await getFromAPI("FtsCountries/");
                setCountries(response); // Save country data
            } catch (error) {
                return null;
            }
        };

        fetchCountryData();
    }, []);

    const handleCountryChange = async (e) => {
        const selectedCountry = e.target.value;
        setInputData(prevState => ({ ...prevState, country: parseInt(selectedCountry) }));

        try {
            const response = await getFromAPI(`FtsState/?country_code=${selectedCountry}`);
            setStates(response); // Save state data
            setCities([]); // Reset city data
        } catch (error) {
            return null;
        }
    };

    const handleStateChange = async (e) => {
        const selectedState = e.target.value;
        setInputData(prevState => ({ ...prevState, state: parseInt(selectedState) }));

        try {
            const response = await getFromAPI(`FtsCity/?state_id=${selectedState}`);
            setCities(response); // Save city data
            // Set the first city as default if cities are available
            if (response && response.length > 0) {
                setInputData(prevState => ({
                    ...prevState,
                    city: response[0].id
                }));
            }
        } catch (error) {
            return null;
        }
    };


    const handleSubmit = async () => {
        if (!inputData.company_name || !inputData.company_name.trim()) {  // Fix: Add parentheses to trim()
            toast.error(messages.vendor.company_name_required, 'error');
            return;
        }
        if (!inputData.name || !inputData.name.trim()) {  // Fix: Add parentheses to trim()
            toast.error(messages.vendor.contact_person_name_required, 'error');
            return;
        }

        if (!inputData.phone_number1 || inputData.phone_number1.length != 10) {
            toast.error(messages.vendor.phone_number_required, 'error');
            return;
        }

        try {
            const response = await postToAPI("add_vendor/", inputData);
            if (response.status) {
                toast.success(messages.vendor.vendor_added_successfully, 'success');
                setInputData(initialInputData);
                addVendorClose();
            } else {
                toast.error(messages.vendor.failed_to_add);
            }
        } catch (error) {
            return null;
        }
    };

    const handleCancel = () => {
        addVendorClose();
        setInputData(initialInputData);
    };

    const handleInputChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };

    const rows = [
        {
            columns: [
                { size: { lg: 6 }, label: 'Vendor Name', type: 'text', name: 'company_name', id: 'vendorName', placeholder: 'Enter name...', value: inputData.company_name, errormsg: '', },
                { size: { lg: 6 }, label: 'Contact Person Name', type: 'text', name: 'name', id: 'name', placeholder: 'Enter Contact Person name...', value: inputData.name, errormsg: '', },
                { size: { lg: 6 }, label: 'Mobile Number', type: 'number', name: 'phone_number1', id: 'vendorNumber', placeholder: 'Enter Contact Person name...', value: inputData.phone_number1, errormsg: '', },
                { size: { lg: 6 }, label: 'Email', type: 'email', name: 'email', id: 'vendorEmail', placeholder: 'Enter email...', value: inputData.email, errormsg: '', },
                { size: { lg: 6 }, label: 'GST', type: 'text', name: 'gst_number', id: 'vendorGstNumber', placeholder: 'Enter gst number...', value: inputData.gst_number, errormsg: '', },
                {
                    size: { md: 6, lg: 4 }, label: 'Country', type: 'select', name: 'country', id: 'country', value: inputData.country, errormsg: '',
                    options: [
                        { value: '', label: 'Select Country' },
                        ...countries.map(item => ({ value: item.calling_code, label: item.short_name }))
                    ],
                },
                {
                    size: { md: 6, lg: 4 }, label: 'State', type: 'select', name: 'state', id: 'state', value: inputData.state, disabled: !states.length, errormsg: '',
                    options: [
                        { value: '', label: 'Select State' },
                        ...states.map(item => ({ value: item.state_id, label: item.state_name }))
                    ],
                },
                {
                    size: { md: 6, lg: 4 }, label: 'City', type: 'select', name: 'city', id: 'city', value: inputData.city, disabled: !cities.length, errormsg: '',
                    options: [
                        { value: '', label: 'Select City' },
                        ...cities.map(item => ({ value: item.id, label: item.city_name }))
                    ],
                },
                {
                    size: { md: 6, lg: 4 }, label: 'Tax', type: 'select', name: 'tax', id: 'tax', value: inputData.tax, errormsg: '',
                    options: [
                        { value: '', label: 'Select Tax' },
                        ...TempDataOption.TempTransactionTaxType.map((data, i) => ({ value: data.transactionTaxTypeOption, label: data.transactionTaxTypeOption }))
                    ],
                },
                { size: { md: 6, lg: 4 }, label: 'PAN', type: 'text', name: 'pan_card_number', id: 'vendorPan', placeholder: 'Enter pan...', value: inputData.pan_card_number, aditionalClass: 'text-uppercase', errormsg: '', },
                { size: { md: 6, lg: 4 }, label: 'Opening Balance', type: 'number', name: 'opening_balance', id: 'vendorOpeningBalance', placeholder: 'Enter Opening Balance...', value: inputData.opening_balance, errormsg: '', },
                {
                    size: { md: 6 }, label: 'Tax', type: 'select', name: 'select_tax', id: 'select_tax', value: inputData.select_tax, errormsg: '',
                    options: [
                        { value: '', label: 'Select Tax' },
                        ...TempDataOption.TempTaxType.map((data, i) => ({ value: data.taxTypeOption, label: data.taxTypeOption }))
                    ],
                },
                {
                    size: { md: 6 }, label: 'Tax Type', type: 'select', name: 'tax_type', id: 'tax_type', value: inputData.tax_type, errormsg: '',
                    options: [
                        { value: '', label: 'Select Tax' },
                        ...TempDataOption.TempGstTaxType.map((data, i) => ({ value: data.gstTaxTypeOption, label: data.gstTaxTypeOption }))
                    ],
                },
            ]
        }
    ];
    const Buttons = [
        { variant: "primary", text: "Add", onClick: handleSubmit },
        { variant: "secondary", text: "Cancel", onClick: handleCancel },
    ]

    return (
        <>
            <Modal centered show={addVendorShow} onHide={addVendorClose} backdrop="static" size='lg'>
                <Modal.Header className='custom-close-btn' closeButton></Modal.Header>
                <Modal.Body>
                    <h5 className='mb-4'>Add New Vendor</h5>
                    <FormInputs Buttons={Buttons} rows={rows} handleInputChange={handleInputChange} handleSubmit={handleSubmit} />
                </Modal.Body>
            </Modal>
        </>
    )
}
